import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parseDate, getLocalTimeZone } from '@internationalized/date';
import { Label, Button } from 'react-aria-components';
import { formatISO, sub, format } from 'date-fns';
import { selectModifiedFilter } from '@pages/filter/store/selectors';
import { setDateRange } from '@pages/filter/store/slice';
import { DateRangePicker } from 'components/date-picker/DateRangePicker';
import { DateRange } from '@project-types/DateRange';



export const FilterDates = () => {

	const modifiedFilter = useSelector(selectModifiedFilter);
	const dispatch = useDispatch();
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));

	const handleLastWeek = useCallback(() => {
		const now = new Date();
		const lastWeek = sub(now, { days: 7 });
		updateDateRange({
			from: formatISO(lastWeek),
			to: formatISO(now),
		});
	},[]);

	const handleLastMonth = useCallback(() => {
		const now = new Date();
		const lastMonth = sub(now, { months: 1 });
		updateDateRange({
			from: formatISO(lastMonth),
			to: formatISO(now),
		});
	},[]);

	const handleLastYear = useCallback(() => {
		const now = new Date();
		const lastYear = sub(now, { years: 1 });
		updateDateRange({
			from: formatISO(lastYear),
			to: formatISO(now),
		});
	},[]);

	return (
		<div className='filter-dates'>

			<Label>Časový harmonogram</Label>

			<DateRangePicker
				label='Od - Do'
				value={
					modifiedFilter.dateFrom && modifiedFilter.dateTo
					? {
						start: parseDate(format(modifiedFilter.dateFrom, 'yyyy-MM-dd')),
						end: parseDate(format(modifiedFilter.dateTo, 'yyyy-MM-dd'))
					}
					: null
				}
				onChange={(rangeValue) => {
					if (rangeValue) {
						updateDateRange({
							from: formatISO(rangeValue.start.toDate(getLocalTimeZone())),
							to: formatISO(rangeValue.end.toDate(getLocalTimeZone())),
						});
					}
				}}
			/>

			<div className='filter-dates-buttons'>
				<Button
					className='app-highlight-button btn'
					onPress={handleLastWeek}>
						Poslední týden
				</Button>

				<Button
					className='app-highlight-button btn'
					onPress={handleLastMonth}>
						Poslední měsíc
				</Button>

				<Button
					className='app-highlight-button btn'
					onPress={handleLastYear}>
						Posledních 12 měsíců
				</Button>
			</div>
				
		</div>
	)
}

export default FilterDates;